import React from 'react';
import { LinkedinIcon } from 'lucide-react';
export function Footer() {
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Experience',
    href: '#experience'
  }, {
    name: 'Expertise',
    href: '#expertise'
  }, {
    name: 'Recognition',
    href: '#recognition'
  }, {
    name: 'Education',
    href: '#education'
  }];
  return <footer className="bg-navy border-t border-gold/30 py-12" data-id="element-146">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-8" data-id="element-147">
        {/* Left - Brand & Copyright */}
        <div className="flex flex-col items-center md:items-start gap-2" data-id="element-148">
          <div className="flex items-center gap-3" data-id="element-149">
            <span className="font-serif text-2xl text-gold font-semibold tracking-wide" data-id="element-150">
              OJ
            </span>
            <span className="w-px h-5 bg-gold/40" data-id="element-151"></span>
            <span className="font-sans text-xs uppercase tracking-widest text-white/70 font-medium" data-id="element-152">
              Ole Jensen
            </span>
          </div>
          <p className="font-sans text-white/40 text-xs mt-2" data-id="element-153">
            &copy; {new Date().getFullYear()} Dr. Ole T. Jensen. All Rights
            Reserved.
          </p>
        </div>

        {/* Center - Links */}
        <nav className="flex flex-wrap justify-center gap-x-8 gap-y-4" data-id="element-154">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-white/60 hover:text-gold text-xs font-sans uppercase tracking-widest transition-colors" data-id="element-155">
              {link.name}
            </a>)}
        </nav>

        {/* Right - Social */}
        <div className="flex items-center gap-4" data-id="element-156">
          <a href="#" className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-white/60 hover:text-gold hover:border-gold hover:bg-gold/10 transition-all" aria-label="LinkedIn Profile" data-id="element-157">
            <LinkedinIcon size={18} data-id="element-158" />
          </a>
        </div>
      </div>
    </footer>;
}